<div class='header'>
    <div class='title-area'>
      <h2 class='title' [hidden]='detailsVisible'>Add {{pemName}}</h2>
      <button class='cancel' [hidden]='detailsVisible' (click)='cancel()'>Cancel</button>
      <button class='back' [hidden]='!detailsVisible' (click)='back()'><i class='mt-left'></i>Back</button>
      <button class='add-pem' [hidden]='!detailsVisible' (click)='addPem()'><i class='mt-plus'></i>Add {{pemName}}</button>
    </div>
  </div>
  
  <div class='add-pem-section' [hidden]='detailsVisible'>
    <div class='selectors'>
      <!-- <p class='error' >You need 2 more SWOW</p>
      <p class='error'>You need 3 more XYZ</p> -->
      <div class='slider'>
        <button class='library' [ngClass]='{"selected": mtLibrarySelected}' (click)='selectMTLibrary()'>MT Library</button>
        <button class='custom' [ngClass]='{"selected": !mtLibrarySelected}' (click)='selectCustomPem()'>Custom {{pemName}}</button>
      </div>
      <div class='library-options' [hidden]='!mtLibrarySelected'>
        <div class='search'>
          <label>Search</label>
          <input placeholder='Keywords' [(ngModel)]='searchText'>
        </div>

        <div class='filter-controls'>
            <button class='toggle-filters' (click)='toggleFilters()'>{{toggleFiltersText}}</button>
            <button class='clear-filters' [hidden]='!anyFilterSelected()' (click)='clearFilters()'>Clear Filters</button> 
            <p class='pem-count'>{{pems.length}} {{pemName}}s</p>    
        </div>
  
        <div class='filters scrollable-y' [hidden]='!filtersVisible'>
          <div class='divider'></div>
          <div *ngFor='let section of filter.sections'>
            <p>{{section.name}}</p>
            <div class='options'>
              <ng-container *ngFor='let item of section.items'>
                <button class='pill' [ngClass]='{"selected": item.selected}' (click)='toggleFilter(section, item)'>{{item.name}}</button>
              </ng-container>
            </div>
          </div>
        </div>      
      </div>
    </div>
  
    <div class='library-pems' [hidden]='!mtLibrarySelected'>
      <div class='pem' *ngFor='let pem of pems; trackBy: trackByPemUuid'>
        <div class='plus' (click)='addSelectedPem(pem)'><i class='mt-plus'></i></div>
        <div class='content' (click)='addSelectedPem(pem)'>
          <h3 class='title'>{{pem.name}}</h3>
          <p class='description' [innerHTML]='pem.description'></p>
        </div>
        <div class='more' (click)='showDetails(pem)'><i class='mt-right'></i></div>
      </div>
    </div>
  
    <div class='custom-pem' [hidden]='mtLibrarySelected'>
      <div class='content'>
        <div class='labeled-entry'>
          <label>{{pemName}} Name</label>
          <input placeholder='My PEM Title' [(ngModel)]="customPem.name">
        </div>
        <div class='labeled-entry'>
          <label>Description</label>
          <textarea id='custom-pem-description' placeholder='It is important to show your child...' [style.height]='textareaHeight("custom-pem-description", 200)' [(ngModel)]='customPem.description'></textarea>
        </div>
        <button class='add' (click)='addCustomPem()'>Add</button>
      </div>
    </div>      
  </div>
  
  <div class='pem-detail-section' [hidden]='!detailsVisible'>
    <app-pem-detail [pem]='detailPem'></app-pem-detail>
  </div>
  